import React from 'react'
import DownloadPlatformsSection from '../../sections/DownloadPlatformsSection'
import { DownloadPlatformsSliceProps } from './types'

const DownloadPlatformsSlice: React.FC<DownloadPlatformsSliceProps> = ({ slice }) => {
  const { dp_title, dp_description } = slice.primary || {}

  return (
    <DownloadPlatformsSection
      paddingTop={['5rem', '4rem', '']}
      paddingBottom={['5rem', '4rem', '']}
      data={{
        title: dp_title?.text,
        subtitle: dp_description?.text,
        listItems: (slice.items || []).map((item) => {
          const { dp_platform_title: head = '' } = item || {}

          const platforms = [
            { url: item?.dp_platform_1_link?.url || '#1', urlText: item?.dp_platform_1_label || '', label: item?.dp_platform_1_icon },
            { url: item?.dp_platform_2_link?.url || '#1', urlText: item?.dp_platform_2_label || '', label: item?.dp_platform_2_icon },
            { url: item?.dp_platform_3_link?.url || '#1', urlText: item?.dp_platform_3_label || '', label: item?.dp_platform_3_icon },
            { url: item?.dp_platform_4_link?.url || '#1', urlText: item?.dp_platform_4_label || '', label: item?.dp_platform_4_icon }
          ].filter((platform) => !!platform.urlText)

          return { head, platforms }
        })
      }}
      bgColor="#F8FAFF"
      inner="inners.primary"
      listItems={[]}
    />
  )
}

export default DownloadPlatformsSlice
